import { Selector } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import { setAutoFreeze } from 'immer';

import { searchMiddleware } from 'app/views/layout/views/search/search.middleware';
import { busylightMiddleware } from 'app/views/layout/views/settings/views/preferences/views/preferencesConnectedDevices/views/busylight/busylight.middleware';
import { electronMiddleware } from 'middleware/electron';
import { jabraMiddleware } from 'middleware/jabra/';
import { notificationMiddleware } from 'middleware/notification';
import { presenceMiddleware } from 'middleware/presence';
import { pwaMiddleware } from 'middleware/pwa';
import { twilioMiddleware } from 'middleware/twilio/middleware';
import { visibilityMiddleware } from 'middleware/visibility/middleware';
import { websocketMiddleware } from 'middleware/websocket/middleware';
import { setupStore } from 'store';

import { createReducer } from './reducer';
import { sagas } from './sagas';

/** Represents the dispatch capable of dealing with regular actions and thunks. */
export type AppDispatch = typeof store.dispatch;

/** Represents the inferred app state from the store. */
export type AppState = ReturnType<ReturnType<typeof createReducer>>;

/** Represents a selector function that selects a value from the store. */
export type AppSelector<TReturn> = Selector<AppState, TReturn>;

// immer@8 automatically freezes any state trees that are modified using
// `produce`. This reverts to the older behavior, where auto-freezing is not
// enabled in production.
setAutoFreeze(process.env.NODE_ENV !== 'production');

// BROWSER HISTORY
// Setup browser history
/** The history object. */
export const history = createBrowserHistory({
  window,
});

// REDUX
// Setup Redux
const middlewares = [
  websocketMiddleware(),
  electronMiddleware(),
  jabraMiddleware(),
  busylightMiddleware(),
  twilioMiddleware(),
  visibilityMiddleware(),
  searchMiddleware(),
  pwaMiddleware(),
  presenceMiddleware(),
  notificationMiddleware(),
];
export const store = setupStore(sagas, middlewares);

export type BootstrapStore = typeof store;
